import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkIconSize, UitkIcon } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-button-toggle.css';

var getClassNameList = classNames.bind(styles);
var UitkButtonToggleLabelOptions;
(function (UitkButtonToggleLabelOptions) {
    UitkButtonToggleLabelOptions[UitkButtonToggleLabelOptions["ICON_FIRST"] = 1] = "ICON_FIRST";
    UitkButtonToggleLabelOptions[UitkButtonToggleLabelOptions["TEXT_FIRST"] = 2] = "TEXT_FIRST";
})(UitkButtonToggleLabelOptions || (UitkButtonToggleLabelOptions = {}));
var UitkButtonToggle = function (props) {
    var altText = props.altText, checked = props.checked, className = props.className, disabled = props.disabled, icon = props.icon, iconSize = props.iconSize, id = props.id, name = props.name, onChange = props.onChange; props.label; var labelText = props.labelText, stacked = props.stacked, subLabelText = props.subLabelText, attributes = __rest(props, ["altText", "checked", "className", "disabled", "icon", "iconSize", "id", "name", "onChange", "label", "labelText", "stacked", "subLabelText"]);
    var wrapperClassName = getClassNameList('uitk-button-toggle', className, {
        'is-checked': checked,
        'is-disabled': disabled
    });
    var contentClassName = getClassNameList('uitk-button-toggle-content', {
        'uitk-button-toggle-content-stacked': stacked
    });
    var labelTextClassName = getClassNameList('label-text', {
        'label-text-bold': subLabelText
    });
    var subLabelTextClassName = getClassNameList('label-text');
    var iconClassName = getClassNameList('uitk-button-toggle-icon', {
        stacked: stacked
    });
    var a11ylabel = '';
    if (labelText) {
        a11ylabel = "".concat(labelText, ". ").concat(subLabelText || '');
    }
    else {
        a11ylabel = "".concat(subLabelText || '');
    }
    return (React.createElement("div", { className: wrapperClassName },
        React.createElement("input", __assign({ id: id, name: name, type: "checkbox", onChange: onChange, className: getClassNameList('is-visually-hidden'), disabled: disabled, checked: checked, "aria-checked": checked, value: checked ? 'true' : 'false' }, attributes)),
        React.createElement("label", { className: contentClassName, htmlFor: id, "aria-label": altText || a11ylabel.trim() },
            icon && React.createElement(UitkIcon, { className: iconClassName, name: icon, size: iconSize }),
            labelText && React.createElement("span", { className: labelTextClassName }, labelText),
            stacked && subLabelText && React.createElement("span", { className: subLabelTextClassName }, subLabelText))));
};
UitkButtonToggle.displayName = 'UitkButtonToggle';
UitkButtonToggle.defaultProps = {
    checked: false,
    disabled: false,
    iconSize: UitkIconSize.MEDIUM,
    stacked: false
};

export { UitkButtonToggle, UitkButtonToggleLabelOptions };
